import { useNavigate } from "react-router-dom";
import "../componentsStyle.scss";
import { PrimaryButton } from "../PrimaryButton";
export const PackageCard = ({ packageItem, languageId }) => {
  const navigate = useNavigate();

  const onOpenIntenerary = () => {
    navigate("/tour-intenerary", {
      state: {
        id: packageItem.id,
      },
    });
  };

  return (
    <div className="package-card">
      <div className="imageContainer">
        <img
          src={packageItem.img}
          width={"100%"}
          height={"100%"}
          alt={packageItem.title[languageId].label}
          className="image"
        />
      </div>
      <div className="logoContainer">
        <div className="logo">{packageItem.svg}</div>
      </div>
      <div className="description">
        <div className="title">{packageItem.title[languageId].label}</div>
        <div className="des">
          {packageItem.description[languageId].label ?? ""}{" "}
        </div>
        <div className="price">
          <span className="amount">€{packageItem.price}</span>
          <span> / person</span>
        </div>

        {/* {packageItem.id === 1 ? (
          <PrimaryButton label={"Comming Soon"} type={"outline"} />
        ) : ( */}
        <PrimaryButton
          onClick={() => onOpenIntenerary()}
          label={"Book Now"}
          type={"primary"}
        />
        {/* )} */}
      </div>
    </div>
  );
};
